import React, { useCallback } from "react";
import { useDispatch } from "react-redux";

import MapMarker from "../MapMarker/MapMarker";

// Info marker configuration
import { configMarker } from "./configMarker";

// helpers
import { iconServiceType } from "helpers/getIcon";

// action creator
import { openOrder, closeOrder } from "redux/ducks/ordersHistory";

const HistoryMapMarkers = ({ orders = [], color }) => {
  const dispatch = useDispatch();
  const handleOpen = useCallback((id) => dispatch(openOrder(id)), [dispatch]);
  const handleClose = useCallback((id) => dispatch(closeOrder(id)), [dispatch]);

  return (
    <React.Fragment>
      {orders.map((item) => {
        return (
          <MapMarker
            key={`${item.id}`}
            item={item}
            onSelect={!item.isOpen ? handleOpen : handleClose}
            isOpen={item.isOpen}
            idMarker="id"
            lat={item.latitude}
            lng={item.longitude}
            config={configMarker}
            color={color}
            onCloseInfo={handleClose}
            icon={`${iconServiceType(item.account)}`}
          />
        );
      })}
    </React.Fragment>
  );
};

export default React.memo(HistoryMapMarkers);
